"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Link_1 = __importDefault(require("../Link"));
var Text_1 = __importDefault(require("../Text"));
var Box_1 = __importDefault(require("../Box"));
var Image_1 = __importDefault(require("../Image"));
var MoreLinksContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        _b[theme.mediaQueries.md] = {
            flexDirection: 'row'
        },
        _b);
});
var MoreLink = (0, styled_1.default)(Link_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        fontSize: theme.fontSizes[0]
    });
});
function Copyright(props) {
    var _a, _b;
    var copyright = props.copyright;
    if ((_a = copyright === null || copyright === void 0 ? void 0 : copyright.text) === null || _a === void 0 ? void 0 : _a.includes('{year}')) {
        copyright.text = copyright.text.replace('{year}', new Date().getFullYear().toString());
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Text_1.default, { fontSize: 0 }, copyright === null || copyright === void 0 ? void 0 : copyright.text),
        react_1.default.createElement(MoreLinksContainer, null,
            (copyright === null || copyright === void 0 ? void 0 : copyright.link_url) &&
                react_1.default.createElement(MoreLink, { href: copyright.link_url },
                    (copyright === null || copyright === void 0 ? void 0 : copyright.icon_url) && react_1.default.createElement(Image_1.default, { src: copyright.icon_url, alt: 'link' }), copyright === null || copyright === void 0 ? void 0 :
                    copyright.link_text), (_b = copyright === null || copyright === void 0 ? void 0 : copyright.moreLinks) === null || _b === void 0 ? void 0 :
            _b.map(function (_a) {
                var _b = _a.url, url = _b === void 0 ? '' : _b, _c = _a.text, text = _c === void 0 ? '' : _c, icon_url = _a.icon_url;
                return (react_1.default.createElement(MoreLink, { key: "" + url + text, href: url },
                    icon_url && react_1.default.createElement(Image_1.default, { src: icon_url, alt: 'link' }),
                    text));
            }))));
}
exports.default = Copyright;
